import { render, staticRenderFns } from "./PaymentSuccessMessage.vue?vue&type=template&id=b14d6194"
import script from "./PaymentSuccessMessage.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccessMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports